import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'
import 'react-toastify/dist/ReactToastify.css'
// import 'react-datepicker/dist/react-datepicker.min.css'
import 'react-phone-number-input/style.css'
import App from './App'
import Loader from 'Router/Loader'
import 'assets/css/custom.css'
import reportWebVitals from './reportWebVitals'
import { StyledEngineProvider } from '@mui/material'

ReactDOM.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <Suspense fallback={<Loader />}>
        <App />
      </Suspense>
    </StyledEngineProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
